import BetaBadge from "./BetaBadge.en";
import LiteScroller from "./LiteScroller.en";
import ShowMore from "./ShowMore.en";

export default {
	BetaBadge,
	LiteScroller,
	ShowMore,
};
